




























































import { Component, Mixins, Prop } from 'vue-property-decorator';
import PretensionController from '@/controllers/Pretension';
import UserMixin from '@/mixins/UserMixin';
import { AccountingSheetInterface } from '@/types/AccountingSheet';
import { formatDateTimeDdMmYyyyHhMm, humanizePretensionStatus } from '@/utils/pretensionsReportDisplay';
import { sheetClosedReason, sheetPretensionQuery } from '@/utils/sheetPretensions';

// ponytail: одна страница на 100 претензий, порядок и страницы по 5 — на фронте: PHP-список
// не сортирует. На проде у листа не больше трёх претензий; вырастет — ORDER BY id DESC
// в Search и pageFrom/pageSize отсюда.
const PRETENSIONS_OF_SHEET_LIMIT = 100;

/**
 * Выпущенные претензии листа учёта (задача 10833), новые сверху. Черновики сюда не попадают:
 * список претензий их не отдаёт. Поставщику коннектор отдаёт только его претензии.
 */
@Component
export default class SheetPretensions extends Mixins(UserMixin) {
  @Prop({ required: true })
  readonly sheet!: AccountingSheetInterface;

  headers = [
    { text: '№ претензии', value: 'sequence', sortable: false },
    { text: 'Тип', value: 'typeName', sortable: false },
    { text: 'Статус', value: 'statusName', sortable: false },
    { text: 'Период', value: 'period', sortable: false },
    { text: 'Сумма без НДС', value: 'total_without_tax', sortable: false },
    { text: 'Дата создания', value: 'createdAt', sortable: false },
  ];

  items: Array<Record<string, any>> = [];

  loading = false;

  loadFailed = false;

  mounted(): void {
    this.load();
  }

  get rows(): Array<Record<string, any>> {
    return [...this.items]
      .sort((a, b) => Number(b.id) - Number(a.id))
      .map((item) => ({
        ...item,
        typeName: item.type ? String(this.$t(item.type)) : '—',
        statusName: humanizePretensionStatus(
          item.status,
          (key: string) => String(this.$t(key)),
          this.isSupplier ? 'supplier' : undefined,
        ),
        period: `${item.date_from || ''} - ${item.date_to || ''}`,
        createdAt: formatDateTimeDdMmYyyyHhMm(item.created_at ?? null),
      }));
  }

  async load(): Promise<void> {
    if (!this.sheet?.id) {
      return;
    }
    this.loading = true;
    this.loadFailed = false;
    try {
      const response = await PretensionController.list({
        sheetIds: [this.sheet.id],
        pageFrom: 0,
        pageSize: PRETENSIONS_OF_SHEET_LIMIT,
      });
      const [error, result] = response.result;
      if (error || !Array.isArray(result?.data)) {
        console.error('[SheetPretensions] list failed', error);
        this.loadFailed = true;
        return;
      }
      this.items = result.data;
    } catch (e) {
      console.error(e);
      this.loadFailed = true;
    } finally {
      this.loading = false;
    }
  }

  /** Почему претензию по этому листу не выпустить; null — кнопка работает (решение 35 плана). */
  get createDisabledReason(): string | null {
    return sheetClosedReason(this.sheet?.status);
  }

  createPretension(): void {
    this.$router.push({ name: 'Pretensions', query: sheetPretensionQuery(this.sheet) });
  }
}
